import { render, staticRenderFns } from "./BrandPartsAttributeAddLayer.vue?vue&type=template&id=7cf9347e&scoped=true&"
import script from "./BrandPartsAttributeAddLayer.vue?vue&type=script&lang=js&"
export * from "./BrandPartsAttributeAddLayer.vue?vue&type=script&lang=js&"
import style0 from "./BrandPartsAttributeAddLayer.vue?vue&type=style&index=0&id=7cf9347e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf9347e",
  null
  
)

export default component.exports